var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{staticStyle:{"display":"inline"},attrs:{"content":_vm.tip,"disabled":!_vm.tip}},[_c('span',{staticClass:"base-tag",style:(`background:${_vm.color || 'var(--primary)'};color:${_vm.textColor || '#fff'};`)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }